import React from "react";
import axios from "axios";
import {Input} from "antd";
import {CircularProgress} from "@material-ui/core";

import { axiosInstance as axioses } from "../../config/axios";

const CheckSheba = () => {
    const [loading, setLoading] = React.useState(false);
    const [shebaName, setShebaName] = React.useState("");
    const [sheba, setSheba] = React.useState("");

    async function onCheckSheba() {
        setLoading(true);
        try {
            const config = {
                method: "GET",
                url: `check_shaba_id?iban=IR${sheba}`
            };
            const {data} = await axioses(config);
            setShebaName(data.data.owners_info[0].first_name + " " + data.data.owners_info[0].last_name);
        } catch (err) {

        } finally {
            setLoading(false);
        };
    };

    return (
        <div className="check-sheba">
            <h1>
                شماره شبا را وارد کنید
            </h1>
            <div className="check-sheba-input">
                <Input
                    placeholder="شماره شبا"
                    value={sheba}
                    maxLength={24}
                    type="tel"
                    name="sheba"
                    style={{ textAlign: "left" }}
                    onChange={e => setSheba(e.target.value)}
                    // onBlur={e => handleValidateNumber(e)}
                />
                <span className="check-sheba-ir">-IR</span>
            </div>
            <button onClick={onCheckSheba} className="check-sheba-btn">
                {
                    loading
                    ? <CircularProgress color="inherit" size={20} />
                    : "چک کردن شبا"
                }
            </button>
            <p className="error-txt" style={{ display: loading ? "none" : "flex", 
                alignSelf: "center", marginTop:'10px' }}
            >
                {shebaName}
            </p>
        </div>
    );
};
export default React.memo(CheckSheba);